<template>
  <div>
    <v-row>
      <v-col md="8">
        <v-card >
          <StatisticUserTable></StatisticUserTable>
        </v-card>
      </v-col>
      <v-col>
        <v-card md="auto">
         <StatisticUsersOverviewCard></StatisticUsersOverviewCard>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StatisticUserTable from "@/pages/admin/components/statistic/users/table/statisticUserTable"
import StatisticUsersOverviewCard from "@/pages/admin/components/statistic/users/card/statisticUsersOverviewCard"
export default {
  components:{
    StatisticUserTable,
    StatisticUsersOverviewCard
  },
  data(){
    return{

    }
  }
}
</script>